import { LogicalType } from '../LogicalType';
import { ParameterObject, ParameterObjectBuilder } from './ParameterObject';
export class ParameterDict extends ParameterObject {
    constructor(items = {}, tags) {
        super(items, new LogicalType('Dict', 1), tags);
    }
    static new() {
        return new ParameterDictBuilder();
    }
}
export class ParameterDictBuilder extends ParameterObjectBuilder {
    setLogicalType() {
        throw new Error('logicalType cannot be set for ParameterDict');
    }
    build() {
        return new ParameterDict(this.items);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyYW1ldGVyRGljdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvb2JqZWN0L1BhcmFtZXRlckRpY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGdCQUFnQixDQUFBO0FBRzVDLE9BQU8sRUFBRSxlQUFlLEVBQUUsc0JBQXNCLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQTtBQUUzRSxNQUFNLE9BQU8sYUFFWCxTQUFRLGVBQWtCO0lBQzFCLFlBQ0UsUUFFb0MsRUFBRSxFQUN0QyxJQUFlO1FBRWYsS0FBSyxDQUFDLEtBQUssRUFBRSxJQUFJLFdBQVcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDaEQsQ0FBQztJQUVELE1BQU0sQ0FBQyxHQUFHO1FBR1IsT0FBTyxJQUFJLG9CQUFvQixFQUFLLENBQUE7SUFDdEMsQ0FBQztDQUNGO0FBRUQsTUFBTSxPQUFPLG9CQUVYLFNBQVEsc0JBQXlCO0lBQ2pDLGNBQWM7UUFDWixNQUFNLElBQUksS0FBSyxDQUFDLDZDQUE2QyxDQUFDLENBQUE7SUFDaEUsQ0FBQztJQUVELEtBQUs7UUFDSCxPQUFPLElBQUksYUFBYSxDQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUN6QyxDQUFDO0NBQ0YifQ==